<template>
  <div class="container-1600 relative flex items-center pt-[3px] lt-md:block lt-md:h-auto lt-md:pt-[20px]">
    <!-- Logo -->
    <div class="mr-[38px]">
      <a href="http://www.jxl.ac.cn/" target="_blank" class="lt-md:block lt-md:text-center">
        <img :src="$getImageSrc(imgName)" class="w-[240px] lt-md:inline-block" alt="" />
      </a>
    </div>
    <!-- 导航 -->
    <div class="flex flex-1 lt-md:h-auto">
      <el-menu
        :default-active="activeIndex"
        class="nav flex w-full justify-between lt-md:flex-wrap"
        :class="{ 'el-menu-in-home': activeIndex === '/' }"
        mode="horizontal"
        @select="handleSelect"
        :router="true"
      >
        <el-menu-item
          v-for="item in navCate"
          :index="item.jumpurl.indexOf('/') === 0 ? item.jumpurl : ''"
          :key="item.resmenu_id"
          tabindex="0"
        >
          <span v-if="item.jumpurl.indexOf('/') === 0">
            {{ item.title }}
          </span>
          <a v-else :href="item.jumpurl" target="_blank" class="inline-block h-full">
            <span>联系我们</span>
          </a>
        </el-menu-item>

        <!-- <el-menu-item index="/account" v-if="!!$store.state.token">个人中心</el-menu-item> -->
      </el-menu>
    </div>
    <!-- 登录注册 -->
    <!-- <div class="right-nav flex" v-if="!$store.state.token">
      <span
        class="mr-2 flex h-[30px] cursor-pointer items-center rounded-[10px] bg-[#146ed8] px-[19px] text-[14px] text-white"
        @click="openLoginDialog"
      >
        登录
      </span>
      <span
        class="flex h-[30px] cursor-pointer items-center rounded-[10px] bg-[#146ed8] px-[19px] text-[14px] text-white"
        @click="openRegisterDialog"
      >
        注册
      </span>
    </div> -->
    <!-- 登录信息 -->
    <!-- <div class="right-nav flex items-center" :class="{ 'in-home': activeIndex === '/' }" v-if="!!$store.state.token">
      <div class="flex items-center">
        <el-image :src="$store.state.avatar" class="mr-[10px] h-[40px] w-[40px] rounded-[50%]" />
        <span class="text-[16px]">你好，</span>
        <router-link to="/account" class="text-[16px] underline">{{ $store.state.name }}</router-link>
      </div>
      <el-divider direction="vertical" class="!mx-[13px]"></el-divider>
      <div class="flex cursor-pointer items-center">
        <i class="el-icon-right"></i>
        <span class="ml-[5px] text-[16px] underline" @click="$store.dispatch('logOut')">退出</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import { EventBus } from '@/utils/eventbus';

import { category } from '@/api/position';

export default {
  name: 'Nav',
  data() {
    return {
      activeIndex: '/', // 当前激活的导航
      imgName: 'logo-blue.png', // logo图片名称
      categoryData: [
        {
          recruit_catagory_id: '4',
          pid: '0',
          title: '', // xx招聘
        },
      ],
    };
  },
  methods: {
    // 打开登录弹窗
    openLoginDialog() {
      EventBus.$emit('dialogLoginVisible', true);
    },
    // 打开注册弹窗
    openRegisterDialog() {
      EventBus.$emit('dialogRegisterVisible', true);
    },
    // 导航点击
    handleSelect(key, keyPath) {},
    // 路由变化
    handleChange(path) {
      this.activeIndex = path;

      if (path === '/') {
        this.imgName = 'logo-white.png';
      } else {
        this.imgName = 'logo-blue.png';
      }

      if (path.indexOf('/talent-policy-list') !== -1) {
        this.activeIndex = '/talent-policy';
      }
    },
    // 获取接口数据
    getData() {
      category().then((res) => {
        this.categoryData = res.data.list;
      });
    },
  },
  computed: {
    navCate() {
      return this.$store.state.navCate;
    },
  },
  mounted() {
    this.handleChange(this.$route.fullPath);
    this.getData();
  },
  watch: {
    $route: {
      handler() {
        this.handleChange(this.$route.fullPath);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// 当在首页时，导航栏的样式
.el-menu-in-home {
  background: none;
  .el-menu-item,
  .el-menu-item:focus,
  .el-submenu.is-active {
    color: #fff !important;
    background-color: transparent !important;

    &:hover {
      background-color: transparent !important;
      color: #ebebeb !important;
    }
  }
  ::v-deep .el-submenu__title {
    color: #fff !important;

    &:hover {
      color: #ebebeb !important;
      background-color: transparent !important;
    }
    .el-submenu__icon-arrow {
      color: #fff !important;
    }
  }
}
.in-home {
  color: #fff;
}

// 导航栏样式覆盖
.el-dropdown-menu__item,
.el-menu-item[tabindex='0'],
::v-deep .el-submenu__title {
  font-size: 18px;
}
.el-dropdown-menu__item,
.el-menu-item[tabindex='-1'] {
  font-size: 16px;
  margin-left: 12px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.el-menu--horizontal > .el-menu-item,
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 87px;
  line-height: 90px;
}
.el-menu--horizontal > .el-menu-item.is-active,
::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom-color: #fe983e;
  border-bottom-width: 4px;
}

.el-menu--horizontal > .el-menu-item > a {
  vertical-align: initial;
}
</style>
